import { Skeleton } from "@/components/ui/skeleton";

const TargetSummarySkeleton = () => (
  <div className="space-y-4 bg-card p-4 rounded-radius">
    <div className="flex items-center justify-between">
      <Skeleton className="h-6 w-40" />
      <Skeleton className="h-6 w-28 rounded-full" />
    </div>

    <div className="rounded-radius border border-border">
      <div className="grid grid-cols-6 gap-2 border-b border-border bg-muted/60 px-4 py-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={`summary-head-${index}`} className="h-3 w-full" />
        ))}
      </div>
      {Array.from({ length: 4 }).map((_, rowIndex) => (
        <div
          key={`summary-row-${rowIndex}`}
          className="grid grid-cols-6 gap-2 border-b border-border px-4 py-3 last:border-b-0"
        >
          {Array.from({ length: 6 }).map((__, cellIndex) => (
            <Skeleton
              key={`summary-cell-${rowIndex}-${cellIndex}`}
              className="h-4 w-full"
            />
          ))}
        </div>
      ))}
    </div>

    <div className="grid grid-cols-3 gap-4 rounded-radius border border-border bg-muted/40 p-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={`summary-stat-${index}`} className="space-y-2 text-center">
          <Skeleton className="mx-auto h-6 w-16" />
          <Skeleton className="mx-auto h-3 w-20" />
        </div>
      ))}
    </div>
  </div>
);

export default TargetSummarySkeleton;
